import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { analyticsApi } from 'src/services/analyticsApi'

interface UseGetConversationCategorizationParams {
  fromDate?: string
  pageId: string
  toDate?: string
  type: 'platform' | 'operator'
}

export const useGetConversationCategorizationQuery = (
  params: UseGetConversationCategorizationParams
) => {
  return useQuery({
    enabled: !!params.pageId && !!params.type,
    queryFn: async () => {
      try {
        const response = await analyticsApi().get(
          '/v1_private/inbox-analysis/conversation-categorization',
          {
            params: {
              fromDate: params.fromDate,
              pageId: params.pageId,
              toDate: params.toDate,
              type: params.type,
            },
          }
        )
        return response.data
      } catch (error) {
        // Return null to use mock data fallback
        console.warn(
          'Conversation categorization API not available, using mock data'
        )
        return null
      }
    },
    queryKey: [
      QueryKey.GET_CONVERSATION_CATEGORIZATION,
      params.pageId,
      params.type,
      params.fromDate,
      params.toDate,
    ],
  })
}
